import * as actions from './actions'
import mutations from './mutations'

const state = () => ({
   items: [],
   relatorio: null,
   relatorioUsuDelegacao: null,
   paginaAtual: null,
   totalDePaginas: null,
   registrosPorPagina: null,
   totalDeRegistros: null,
   possuiPaginaAnterior: null,
   possuiProximaPagina: null,
   loadingRelatorios: true,

   cargos: null,
   unidadeLotacao: null,
   patios: null
})

const relatorios = {
   namespaced: true,
   state,
   actions,
   mutations
}

export default {
   relatorios
}
